module.exports = __webpack_public_path__ + "img/cb8c0f6.png";